import { useCallback } from "react"
import { PortalAccountDomain } from "../enums"

const IB_ONBOARDING_ORG: Record<string, {
    domain: PortalAccountDomain
    flow: 'simplified' | 'standard'
    exclude: string[]
}> = {
    "84805": {
        domain: PortalAccountDomain.TMSY,
        flow: "standard",
        exclude: ["AUS", "NZL", "CYP"]
    },
    "63748": {
        domain: PortalAccountDomain.TMSY,
        flow: "standard",
        exclude: ["AUS", "NZL", "CYP"]
    },
    "290985": {
        domain: PortalAccountDomain.TMLC,
        flow: "simplified",
        exclude: ["AUS", "NZL", "CYP"]
    }
}

export const useIBOnboarding = () => {
    const getIBInfo = useCallback((afsAid: string, countryCode3: string) => {
        if (!countryCode3) return undefined
        if (!countryCode3) console.log(`countryCode3 is ${countryCode3}`)
        if (afsAid) {
            const ib = IB_ONBOARDING_ORG[afsAid]
            if (ib && !ib.exclude.includes(countryCode3)) {
                return ib
            }
            return undefined
        }
        return undefined
    }, [])
    return { getIBInfo }
}